const translations = {
  "en": {
    "File size exceeds 20MB limit.": "File size exceeds 20MB limit.",
    "Only PDF, image (PNG/JPG/WEBP), or CSV/Excel files are supported.": "Only PDF, image (PNG/JPG/WEBP), or CSV/Excel files are supported.",
    "Only the first %{var0} document(s) were added due to limit.": "Only the first %{var0} document(s) were added due to limit.",
    "Upload failed. Please try again.": "Upload failed. Please try again.",
    "You can upload up to %{var0} documents.": "You can upload up to %{var0} documents."
  },
  "zh-tw": {
    "File size exceeds 20MB limit.": "檔案大小超過 20MB 限制。",
    "Only PDF, image (PNG/JPG/WEBP), or CSV/Excel files are supported.": "僅支援 PDF、圖片（PNG/JPG/WEBP）或 CSV/Excel 檔案。",
    "Only the first %{var0} document(s) were added due to limit.": "受系統限制，僅新增前 %{var0} 份文件。",
    "Upload failed. Please try again.": "上傳失敗。請再試一次。",
    "You can upload up to %{var0} documents.": "你最多可上傳 %{var0} 份文件。"
  }
};

export default translations;
